/* eslint-disable */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, getIn } from 'formik';
import { makeStyles, TextField, MenuItem } from '@material-ui/core';
import cx from 'classnames';

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 100,
  },
  icon: {
    top: '50%',
    transform: 'translate(0%, -50%)',
  },
}));

const FormikSelectField = ({
                             type,
                             name,
                             backendError,
                             className,
                             menuItems,
                             children,
                             hideErrorAreaIfNoErrors = false,
                             onChange,
                             ...restProps
                           }) => {
  const [isOpen, setOpen] = useState(false);
  const classes = useStyles();

  return (
    <Field type={type} name={name}>
      {({ field, form }) => {
        const frontendError = getIn(form.errors, field.name);
        const touched = getIn(form.touched, field.name);
        return (
          <TextField
            select
            name={field.name}
            value={field.value}
            type={type}
            error={(touched && !!frontendError) || !!backendError}
            helperText={frontendError || backendError || (hideErrorAreaIfNoErrors ? '' : ' ')}
            className={cx(classes.formControl, className)}
            margin='dense'
            variant='outlined'
            onChange={(e) => {
              form.setFieldValue(field.name, e.target.value);
              if (onChange) {
                onChange(e.target.value);
              }
            }}
            onBlur={field.onBlur}
            onKeyDown={(e) => {
              if (!isOpen) {
                e.persist();
              }
            }}
            SelectProps={{
              classes: {
                icon: classes.icon,
              },
              onOpen: () => {
                setOpen(true);
              },
              onClose: () => {
                setOpen(false);
              },
            }}
            {...restProps}
          >
            {children ||
              menuItems.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
          </TextField>
        );
      }}
    </Field>
  );
};

FormikSelectField.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.object),
  backendError: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

FormikSelectField.defaultProps = {
  className: undefined,
  backendError: undefined,
  children: undefined,
  menuItems: undefined,
};

export default FormikSelectField;
